module.exports = __webpack_public_path__ + "img/warning.74c06477.svg";